// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonLaserSpotSize_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.50211 5.99951C8.50211 7.38022 7.38282 8.49951 6.00211 8.49951C4.62139 8.49951 3.50211 7.38022 3.50211 5.99951C3.50211 4.6188 4.62139 3.49951 6.00211 3.49951C7.38282 3.49951 8.50211 4.6188 8.50211 5.99951Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.53694 11.9998 3.89049 8.11076.00140406 8.46431 1.41562 9.87853.00140381 11.2927.708511 11.9998 2.12272 10.5856 3.53694 11.9998ZM8.46341 5.05762e-7 8.10986 3.88909 11.9989 3.53553 10.5847 2.12132 11.9989.707107 11.2918 0 9.87762 1.41421 8.46341 5.05762e-7Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.9506.636719 23.3649 2.05093 20.5364 4.87936 21.9506 6.29357 17.0009 7.00068 17.708 2.05093 19.1222 3.46515 21.9506.636719ZM17.0003 11.9998C17.0003 14.7613 14.7617 16.9998 12.0003 16.9998 9.23888 16.9998 7.0003 14.7613 7.0003 11.9998 7.0003 9.23842 9.23888 6.99985 12.0003 6.99985 14.7617 6.99985 17.0003 9.23842 17.0003 11.9998ZM.635742 21.9488 2.04996 23.363 4.87838 20.5346 6.2926 21.9488 6.9997 16.999 2.04996 17.7061 3.46417 19.1203.635742 21.9488Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonLaserSpotSize is a generated icon component.
 */
let IconCommonLaserSpotSize = IconCommonLaserSpotSize_1 = class IconCommonLaserSpotSize extends IconBaseElement {
    render() {
        return html `${IconCommonLaserSpotSize_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonLaserSpotSize.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonLaserSpotSize = IconCommonLaserSpotSize_1 = __decorate([
    customElement('zui-icon-common-laser-spot-size')
], IconCommonLaserSpotSize);
export { IconCommonLaserSpotSize };
